import { Menu } from "@mantine/core";
import { PaymentLinkMenuItemProps } from "./types";
import { useModals } from "@mantine/modals";
import { ModalComponent } from "components";
import { usePaymentLink } from "hooks";

export function PaymentLinkMenuItem(props: PaymentLinkMenuItemProps) {
  const { invoice } = props;
  const { paymentLink } = usePaymentLink({
    paymentLinkId: invoice.paymentLinkId,
  });

  const modal = useModals();

  function handleClick() {
    if (!paymentLink) return;
    modal.openContextModal("payment-link.view", {
      title: <ModalComponent.Title>Payment Link</ModalComponent.Title>,
      innerProps: { paymentLink },
    });
  }

  if (!paymentLink) return <></>;
  return <Menu.Item onClick={handleClick}>Show Payment Link</Menu.Item>;
}
